// The A1 "First words" starter set — ~36 essential phrases a brand-new learner
// can pick up on day one, before they've generated anything from sentence
// practice. Hand-picked (no AI), grouped loosely greeting → courtesy → meeting
// people → survival. Used by the Starter view (src/views/starter.js).
export const STARTER_PHRASES = [
  { pt: "Olá", en: "Hello" },
  { pt: "Bom dia", en: "Good morning" },
  { pt: "Boa tarde", en: "Good afternoon" },
  { pt: "Boa noite", en: "Good evening / Good night" },
  { pt: "Adeus", en: "Goodbye" },
  { pt: "Até logo", en: "See you later" },
  { pt: "Até amanhã", en: "See you tomorrow" },

  { pt: "Por favor", en: "Please" },
  { pt: "Obrigado", en: "Thank you" },
  { pt: "Muito obrigado", en: "Thank you very much" },
  { pt: "De nada", en: "You're welcome" },
  { pt: "Desculpe", en: "Sorry / Excuse me" },
  { pt: "Lamento", en: "I'm sorry" },
  { pt: "Com licença", en: "Excuse me (to get past)" },

  { pt: "Como estás?", en: "How are you? (informal)" },
  { pt: "Como está?", en: "How are you? (formal)" },
  { pt: "Bem, obrigado", en: "Fine, thanks" },
  { pt: "Mais ou menos", en: "So-so" },
  { pt: "E tu?", en: "And you?" },

  { pt: "Chamo-me…", en: "My name is…" },
  { pt: "Como te chamas?", en: "What's your name?" },
  { pt: "Muito prazer", en: "Nice to meet you" },
  { pt: "Sou de…", en: "I'm from…" },
  { pt: "De onde és?", en: "Where are you from?" },

  { pt: "Sim", en: "Yes" },
  { pt: "Não", en: "No" },
  { pt: "Não sei", en: "I don't know" },
  { pt: "Não percebo", en: "I don't understand" },
  { pt: "Falas inglês?", en: "Do you speak English?" },
  { pt: "Podes repetir, por favor?", en: "Can you repeat, please?" },
  { pt: "Mais devagar, por favor", en: "Slower, please" },
  { pt: "Como se diz…?", en: "How do you say…?" },
  { pt: "O que significa…?", en: "What does … mean?" },
  { pt: "Quanto custa?", en: "How much is it?" },
  { pt: "Onde fica a casa de banho?", en: "Where is the bathroom?" },
  { pt: "Ajuda, por favor", en: "Help, please" },
];
